/**
 * Remembers the page someone was on before they came to Support.
 *
 * The report form used to record the current page, which stopped being useful
 * once the form moved onto the Support page itself — every ticket said
 * "/support". This keeps the last page that wasn't Support, so the form can
 * offer it as the likely answer.
 */
let previous = "";
let current = "";

const IGNORED = ["/support", "/profile"];

export function noteVisit(pathname) {
  if (!pathname || pathname === current) return;
  if (!IGNORED.includes(current) && current) previous = current;
  current = pathname;
}

/** The most recent page that wasn't Support — usually what a report is about. */
export function pageBeforeSupport() {
  return IGNORED.includes(current) ? previous : current;
}
